import { useState } from "react";
import { toast } from "sonner";
import { Phone } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

// Asks users without a phone number (e.g. Google sign-up) to complete their profile.
export const PhoneGate = ({ user, setUser }) => {
  const [open, setOpen] = useState(!user.phone && !sessionStorage.getItem("aurora_phone_later"));
  const [phone, setPhone] = useState("");
  const save = async (e) => {
    e.preventDefault();
    if (phone.replace(/\D/g, "").length < 6) return toast.error("Inserisci un numero di telefono valido");
    try {
      const { data } = await api.patch("/me/profile", { phone });
      setUser(data);
      setOpen(false);
      toast.success("Numero salvato");
    } catch (err) { toast.error(errMsg(err)); }
  };
  const later = () => { sessionStorage.setItem("aurora_phone_later", "1"); setOpen(false); };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && later()}>
      <DialogContent className="bg-[#0a1224] border-cyan-500/30" data-testid="phone-gate-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl flex items-center gap-2"><Phone size={20} className="text-cyan-300" /> Il tuo numero di telefono</DialogTitle>
          <DialogDescription>Completa il profilo: ci serve per assisterti e contattarti in caso di necessità.</DialogDescription>
        </DialogHeader>
        <form onSubmit={save} className="space-y-3">
          <input type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="+41 76 123 45 67" autoFocus data-testid="phone-gate-input"
            className="w-full bg-[#050b18]/80 border border-cyan-500/25 rounded-xl px-4 py-3 text-base outline-none focus:border-cyan-400/60" />
          <div className="flex gap-2">
            <button className="btn-aurora flex-1 rounded-xl py-2.5 text-sm uppercase" data-testid="phone-gate-save">Salva</button>
            <button type="button" onClick={later} className="btn-ghost-hud rounded-xl px-4 text-sm" data-testid="phone-gate-later">Più tardi</button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
